import type {ReactElement} from 'react';
import React from 'react';
import {Dropdown} from '@Components/dropdown-v2';
import {ALIGNMENT_TYPE, DROPDOWN_POSITION} from '@Components/dropdown-v2/dropdown.types';
import {ControlledList} from '@Components/controlled-list';
import type {ControlledListItemType} from '@Components/controlled-list/controlled-list.types';
import {CONTROLLED_LIST_ITEM_TYPE} from '@Components/controlled-list/controlled-list.types';
import styles from './email-maker-success-cta-menu-options.module.scss';

export interface EmailMakerSuccessCtaMenuOptionsProps {
  toggleButton: ReactElement<any>;
  campaignId: string;
  isContentPlannerFlow?: boolean;
  isScheduled: boolean;
}

export default function EmailMakerSuccessCtaMenuOptions({toggleButton, campaignId, isScheduled, isContentPlannerFlow = false}: EmailMakerSuccessCtaMenuOptionsProps): ReactElement<any> {
  const onClickBackToEmailCampaigns = (): void => {
    window.location.href = window.PMW.util.site_url(`posters/mine#/email-marketing-campaigns`);
  };

  const onClickBackToContentPlanner = (): void => {
    window.location.href = window.PMW.util.site_url(`posters/mine#/content-planner`);
  };

  const onClickViewPerformance = (): void => {
    window.location.href = window.PMW.util.site_url(`posters/mine#/email-marketing-campaign-performance/c/${campaignId}`);
  };

  const onClickSendRightNow = (): void => {
    const element = document.querySelector('.js-view-send-campaign-now') as HTMLElement;

    if (element) {
      element.click();
    }
  };

  const getItems = (): Array<ControlledListItemType> => {
    const items: Array<ControlledListItemType> = [];

    if (isScheduled) {
      items.push({
        id: 'item-send',
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        text: window.i18next.t('pmwjs_send_right_now'),
        icon: 'icon-send',
        onClick() {
          onClickSendRightNow();
        },
      });
    } else {
      items.push({
        id: 'item-view-performance',
        onClick() {
          onClickViewPerformance();
        },
        className: 'js-view-performance',
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        text: window.i18next.t('pmwjs_view_campaign_performance'),
        icon: 'icon-bar-chart',
      });
    }

    if (isContentPlannerFlow) {
      items.push({
        id: 'item-back-content-planner',
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        text: window.i18next.t('pmwjs_back_content_planner'),
        icon: 'icon-back',
        onClick() {
          onClickBackToContentPlanner();
        },
      });
    } else {
      items.push({
        id: 'item-back-campaigns',
        type: CONTROLLED_LIST_ITEM_TYPE.DEFAULT_7,
        text: window.i18next.t('pmwjs_back_to_email_campaigns'),
        icon: 'icon-back',
        onClick() {
          onClickBackToEmailCampaigns();
        },
      });
    }

    return items;
  };

  const getPopupMenuItems = (): ReactElement<any> => {
    return <ControlledList items={getItems()} className="spacing-m-0" />;
  };

  const getPopup = (): ReactElement<any> => {
    return <div className={styles.menuWrapper}>{getPopupMenuItems()}</div>;
  };

  return (
    <Dropdown
      modalTitle={window.i18next.t('pmwjs_select_options')}
      showModalForSmallScreen
      position={DROPDOWN_POSITION.FIXED}
      shouldShift={false}
      shouldFlip={false}
      popupOffset={8}
      popupClassName={styles.popupClassname}
      alignment={ALIGNMENT_TYPE.BOTTOM_END}
      selector={toggleButton}
      popUpHasCustomWidth
      popup={getPopup()}
    />
  );
}
